import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [
      "en", "fr", "es", "de", "zh", "hi", "ar", "ru", "ja", "it",
      "nl", "pt", "tr", "ko", "pl", "sv", "da", "fi", "el", "cs",
      "he", "id", "th" // ✅ Add this
    ],

    fallbackLng: "en",
    detection: {
      order: ["path", "localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
  });

export default i18n;
